import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }

import { ref } from "vue";
import type { Ref } from "vue";
import AppNavbar from "@/components/AppNavbar.vue";
import HomeHeader from "@/components/HomeHeader.vue";
import HomeAbout from "@/components/HomeAbout.vue";
// import HomeSkills from "@/components/HomeSkills.vue";
// import HomePortfolio from "@/components/HomePortfolio.vue";
// import HomeContact from "@/components/HomeContact.vue";
import AppFooter from "@/components/AppFooter.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const home = ref(null);
const about = ref(null);
const skills = ref(null);
const portfolio = ref(null);
const contact = ref(null);

const domElements = {
  home: home,
  about: about,
  skills: skills,
  portfolio: portfolio,
  contact: contact,
};

const scrollTo = (id: string) => {
  const windowScrollY = window.scrollY;

  const { top } = (
    domElements[id as keyof typeof domElements] as Ref
  ).value.$el.getBoundingClientRect();

  const topOffeset = window.innerWidth > 1100 ? 110 : 190;

  let elTop;
  if (id == "home") elTop = 0;
  else elTop = Math.abs(windowScrollY * 1 + top * 1 - topOffeset + 130);

  window.scroll({
    top: elTop,
    left: 0,
    behavior: "smooth",
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppNavbar, {
      onActiveChanged: _cache[0] || (_cache[0] = ($event: any) => (scrollTo($event))),
      ref_key: "home",
      ref: home
    }, null, 512),
    _createVNode(HomeHeader),
    _createVNode(HomeAbout, {
      class: "margin-b-big",
      ref_key: "about",
      ref: about
    }, null, 512),
    _createVNode(AppFooter)
  ]))
}
}

})